import React from 'react';

const GooglePlayLogo = () => (
  <svg width="120" height="40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient x1="90.794%" y1="4.825%" x2="-38.461%" y2="71.799%" id="a">
        <stop stopColor="#00A0FF" offset="0%" />
        <stop stopColor="#00A1FF" offset=".7%" />
        <stop stopColor="#00BEFF" offset="26%" />
        <stop stopColor="#00D2FF" offset="51.2%" />
        <stop stopColor="#00DFFF" offset="76%" />
        <stop stopColor="#00E3FF" offset="100%" />
      </linearGradient>
      <linearGradient x1="108.338%" y1="49.919%" x2="-130.363%" y2="49.919%" id="b">
        <stop stopColor="#FFE000" offset="0%" />
        <stop stopColor="#FFBD00" offset="40.9%" />
        <stop stopColor="orange" offset="77.5%" />
        <stop stopColor="#FF9C00" offset="100%" />
      </linearGradient>
      <linearGradient x1="86.559%" y1="17.728%" x2="-49.367%" y2="194.334%" id="c">
        <stop stopColor="#FF3A44" offset="0%" />
        <stop stopColor="#C31162" offset="100%" />
      </linearGradient>
      <linearGradient x1="-19.095%" y1="-53.906%" x2="42.02%" y2="25.136%" id="d">
        <stop stopColor="#32A071" offset="0%" />
        <stop stopColor="#2DA771" offset="6.9%" />
        <stop stopColor="#15CF74" offset="47.6%" />
        <stop stopColor="#06E775" offset="80.1%" />
        <stop stopColor="#00F076" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M115.642 40H4.456C1.924 40 0 37.84 0 35V5c0-2.84 1.924-5 4.456-5H115.54c2.531 0 4.455 2.16 4.455 5v29.886c.102 2.728-1.924 5.114-4.354 5.114z"
        fill="#FFF"
      />
      <path
        d="M115.642.798c2.025 0 3.747 1.937 3.747 4.216v29.972c0 2.279-1.722 4.216-3.747 4.216H4.456c-2.026 0-3.747-1.937-3.747-4.216V5.014C.709 2.735 2.43.798 4.456.798h111.186zm0-.798H4.456C1.924 0 0 2.165 0 5.014v29.972C0 37.835 1.924 40 4.456 40H115.54c2.531 0 4.455-2.165 4.455-5.014V5.014c.102-2.62-1.924-5.014-4.354-5.014z"
        fill="#000"
        fillRule="nonzero"
      />
      <path
        d="M42.4 11.4c0 .7-.2 1.3-.6 1.8-.5.5-1.1.8-1.9.8-.8 0-1.4-.3-1.9-.8s-.8-1.1-.8-1.9c0-.8.3-1.4.8-1.9s1.1-.8 1.9-.8c.4 0 .7.1 1.1.3.4.2.6.4.8.6l-.4.4c-.4-.4-.8-.6-1.4-.6-.5 0-1.1.2-1.4.6-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5c.4.4.9.6 1.4.6.6 0 1.1-.2 1.5-.6.3-.3.4-.6.4-1.1H40v-.6h2.5c-.1-.1-.1.2-.1.2zm4-2.2H44v1.7h2.2v.6H44v1.7h2.4v.7h-3.1V8.6h3.1v.6zm2.9 4.7h-.7V9.2h-1.5v-.6h3.7v.6h-1.5v4.7zm4 0V8.6h.7v5.3h-.7zm3.7 0h-.7V9.2h-1.5v-.6h3.6v.6h-1.5l.1 4.7zm8.4-.7c-.5.5-1.1.8-1.9.8-.8 0-1.4-.3-1.9-.8s-.8-1.1-.8-1.9c0-.8.3-1.4.8-1.9s1.1-.8 1.9-.8c.8 0 1.4.3 1.9.8s.8 1.1.8 1.9c-.1.7-.3 1.3-.8 1.9zm-3.4-.5c.4.4.9.6 1.4.6.5 0 1.1-.2 1.4-.6.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5c-.4-.4-.9-.6-1.4-.6-.5 0-1 .2-1.4.6-.4.4-.6.9-.6 1.5s.2 1.2.6 1.5zm5.1 1.2V8.6h.8l2.5 4.1V8.6h.7v5.3h-.7l-2.7-4.3v4.3h-.6z"
        stroke="#000"
        strokeWidth=".2"
        fill="#000"
        fillRule="nonzero"
      />
      <g transform="translate(9 9)">
        <path d="M.9 1c-.3.3-.4.7-.4 1.2v19.4c0 .5.2 1 .4 1.2l.1.2 10.9-10.9v-.2L.9 1z" fill="url(#a)" />
        <path d="M15.4 15.8l-3.6-3.6v-.3l3.6-3.6.1.1 4.3 2.5c1.2.7 1.2 1.8 0 2.5l-4.4 2.4z" fill="url(#b)" />
        <path d="M15.5 15.7L11.8 12 .8 23c.4.4 1.1.4 1.8.1l12.9-7.4" fill="url(#c)" />
        <path d="M15.5 8.3L2.7 1C1.9.6 1.3.6.9 1.1l11 10.9c-.1 0 3.6-3.7 3.6-3.7z" fill="url(#d)" />
        <path d="M19.8 13.1l-4.4 2.5.1.1 4.3-2.6c.6-.3.9-.7.9-1.1 0 .4-.3.8-.9 1.1z" fill="#FFF" opacity=".12" />
        <path
          d="M2.7 1.1l17.1 9.7c.5.4.9.7.9 1.1 0-.4-.3-.9-.9-1.2L2.7 1.1C1.5.3.5.9.5 2.3v.1c0-1.4 1-2 2.2-1.3z"
          fill="#FFF"
          opacity=".25"
        />
        <path d="M15.4 15.6L2.7 22.8c-.7.4-1.3.4-1.8 0l-.1.1.2.1c.4.4 1.1.4 1.8 0l12.6-7.4z" fill="#FFF" opacity=".2" />
        <path d="M.9 22.8c-.3-.3-.4-.7-.4-1.2v.1c0 .5.2.9.4 1.1z" fill="#FFF" opacity=".12" />
      </g>
      <path
        d="M60.5 22.6c-2.1 0-3.8 1.6-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.6 3.8-3.8 0-2.3-1.7-3.8-3.8-3.8zm0 6c-1.1 0-2.1-1-2.1-2.3 0-1.3 1-2.3 2.1-2.3s2.1.9 2.1 2.3c0 1.3-.9 2.3-2.1 2.3zm-8.1-6c-2.1 0-3.8 1.6-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.6 3.8-3.8-.1-2.3-1.7-3.8-3.8-3.8zm0 6c-1.1 0-2.1-1-2.1-2.3 0-1.3 1-2.3 2.1-2.3s2.1.9 2.1 2.3c0 1.3-1 2.3-2.1 2.3zm-9.8-4.9v1.6h3.8c-.1.9-.4 1.6-.9 2-.5.5-1.4 1.1-2.9 1.1-2.4 0-4.1-1.8-4.1-4.2 0-2.4 1.8-4.2 4.1-4.2 1.2 0 2.2.5 2.9 1.1l1.1-1.1c-1-.9-2.2-1.6-4-1.6-3.2 0-5.9 2.6-5.9 5.8 0 3.2 2.7 5.8 5.9 5.8 1.8 0 3-.5 4-1.7 1.1-1.1 1.4-2.5 1.4-3.7 0-.4 0-.7-.1-1 .2.1-5.3.1-5.3.1zM82.5 25c-.4-.9-1.2-2.4-3.2-2.4s-3.5 1.5-3.5 3.8c0 2.1 1.6 3.8 3.7 3.8 1.7 0 2.7-1.1 3.1-1.7l-1.2-.9c-.4.6-1 1.1-1.8 1.1s-1.4-.4-1.8-1.1l5-2.1c-.1-.1-.3-.5-.3-.5zm-5.1 1.2c0-1.4 1.1-2.2 1.9-2.2.6 0 1.2.4 1.4.8l-3.3 1.4zm-4.1 3.6H75v-11h-1.7v11zm-2.7-6.4c-.4-.4-1.1-.9-2-.9-1.8 0-3.6 1.7-3.6 3.8 0 2.1 1.7 3.7 3.6 3.7.9 0 1.6-.4 1.9-.9h.1v.5c0 1.4-.8 2.2-2 2.2-1 0-1.7-.7-1.8-1.3l-1.4.6c.4 1 1.5 2.2 3.3 2.2 1.9 0 3.5-1.1 3.5-3.9v-6.7h-1.6v.7zm-1.9 5.2c-1.1 0-2.1-1-2.1-2.3 0-1.3 1-2.3 2.1-2.3s2 1 2 2.3c0 1.3-.9 2.3-2 2.3zm21.4-9.8h-4v11h1.7v-4.1h2.3c1.8 0 3.6-1.3 3.6-3.4 0-2.1-1.7-3.5-3.6-3.5zm.1 5.3h-2.4v-3.8h2.4c1.2 0 1.9 1.1 1.9 1.8-.1 1-.8 2-1.9 2zm10.1-1.6c-1.2 0-2.5.5-2.9 1.7l1.5.6c.4-.6.9-.8 1.5-.8.9 0 1.7.5 1.8 1.4v.1c-.3-.2-1-.4-1.7-.4-1.6 0-3.2.9-3.2 2.5 0 1.5 1.3 2.5 2.7 2.5 1.1 0 1.7-.5 2.1-1.1h.1v.9h1.6v-4.2c-.2-2.1-1.7-3.2-3.5-3.2zm-.2 6.1c-.5 0-1.3-.3-1.3-1 0-.9 1-1.1 1.8-1.1.7 0 1.1.2 1.5.4-.2.9-1.1 1.7-2 1.7zm9.2-5.8l-1.8 4.7h-.1l-1.9-4.7h-1.8l2.9 6.7-1.7 3.7h1.7l4.5-10.4h-1.8zm-14.7 7h1.7v-11h-1.7v11z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default GooglePlayLogo;
